import { render, staticRenderFns } from "./right-drawer.vue?vue&type=template&id=ba67d3f2&scoped=true&"
import script from "./right-drawer.vue?vue&type=script&lang=js&"
export * from "./right-drawer.vue?vue&type=script&lang=js&"
import style0 from "./right-drawer.vue?vue&type=style&index=0&id=ba67d3f2&scoped=true&lang=css&"
import style1 from "./right-drawer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba67d3f2",
  null
  
)

export default component.exports